import React, { ReactNode } from 'react';

import { SelectedResource } from '../../../../actions/menuActions';
import { useStudentSelector } from '../../../../store/selectors/useStudentSelector';
import { ItemDetailsType, MenuItem, MenuItemProps } from '../../components/student/MenuItem';
import { Resource } from '@ael/core-api';
import { useDispatch } from 'react-redux';

interface OwnProps {
  item: Resource;
  isLinearModeOn: boolean;
  children?: ReactNode;
}

export const ResourceItem: React.FC<OwnProps> = (ownProps) => {
  const isSelected = useStudentSelector((state) => state.currentResource) === ownProps.item.id;
  const dispatch = useDispatch();

  const props: MenuItemProps = {
    ...ownProps,
    menuItemDetails: {
      active: isSelected,
      itemDetailsType: ItemDetailsType.Resource,
      parentItemId: null,
      itemId: ownProps.item.id,
    },
    onClick: () => {
      dispatch(SelectedResource(ownProps.item.id));
    },
  };

  return <MenuItem {...props} />;
};
